// Styles
import styles from './FlashBoard.module.css';

/**
 * @function FlashBoard
 * Describes the list of currently called numbers
 *
 * @example
 * return (
 *   <FlashBoard called={[]} />
 * )
 */
function FlashBoard({ called }: FlashBoardProps): JSX.Element {
    const title: string = 'BINGO';
    const titleArr: string[] = title.split('');

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                {titleArr.map((item, index) => (
                    <div key={`${item}-${index}`} className={styles.number}>
                        <span>{item}</span>
                    </div>
                ))}
            </header>
            <div className={styles.grid}>
                {[...Array(5)].map((item, index) => {
                    const indexA: number = index;

                    return (
                        <div key={index} className={styles.row}>
                            {[...Array(15)].map((item, index) => {
                                const number: number = indexA * 15 + index + 1;
                                const inCalled: boolean =
                                    called.includes(number);
                                const className: string =
                                    styles.number +
                                    (inCalled ? ` ${styles.called}` : '');

                                return (
                                    <div key={index} className={className}>
                                        {number}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

/**
 * @interface FlashBoardProps
 * Describes the properties required for the FlashBoard component
 *
 * @property {array} called List of called numbers
 */
export interface FlashBoardProps {
    called: number[];
}

// Exports
export default FlashBoard;
